
import { faCamera } from "@fortawesome/free-solid-svg-icons/faCamera";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DadosNotaFiscal, TipoEntrega } from "app/types/pesquisa-orcamento/consultas/NotasFiscais";
import { DadosDaPesquisaOrcamento } from "app/types/pesquisa-orcamento/PesquisaOrcamento";
import clsx from "clsx";
import globalMU from "globalMU";
import React, { useState } from "react";

const estilosInputs = require('../../../estilos/inputs.module.scss').default
const estilosBotoes = require("../../../estilos/botoes.module.scss").default;

export type NotasFiscaisProps = {
    orcamentoSelecionado: Partial<DadosDaPesquisaOrcamento>
    entregas: TipoEntrega[]
    notasFiscais: DadosNotaFiscal[]
    mostrarDetalhesTipoEntrega: boolean
    notaFiscalSelecionada: Partial<DadosNotaFiscal>
    onSelecionarMostrarTipoEntrega: (mostrar: boolean, notaFiscal: DadosNotaFiscal) => void
    onMostrarImagem: (NumOrd: number) => void,
};

export const NotasFiscais = (props: NotasFiscaisProps) => {
    const [tipoEntregaSelecionado, setTipoEntregaSelecionado] = useState<string>("");

    const ocultarValorPedido = () => {
        if(props.notasFiscais.length == 0) {
            return true;
        }

        if (props.notasFiscais.filter(nf => Number.isNaN(Number(nf.ValorTotal))).length > 0) {
            return true;
        }
    }

    const cabecalho =
        <div className="_my-2">
            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Filial</label>
                <p className="_mb-0 _p-2">{props.orcamentoSelecionado.Filial}</p>
            </div>
            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Nº Orçamento</label>
                <p className="_mb-0 _p-2">{props.orcamentoSelecionado.NumeroPedido}</p>
            </div>
            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">CLiente</label>
                <p className="_mb-0 _p-2">{props.orcamentoSelecionado.RazaoSocialCliente}</p>
            </div>
            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Vendedor</label>
                <p className="_mb-0 _p-2">{props.orcamentoSelecionado.Vendedor}</p>
            </div>
            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Data</label>
                <p className="_mb-0 _p-2">{globalMU.formatDate(props.orcamentoSelecionado.DataPedido)}</p>
            </div>
            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Valor</label>
                <p className="_mb-0 _p-2">{ocultarValorPedido() ? "R$ **,**" : globalMU.formatarValorNumerico(props.orcamentoSelecionado.ValorPedido, 2, true)}</p>
            </div>
        </div>

    const entrega = <div className="_flex _items-center">
        <label className="_my-1 _w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Entrega</label>
        <select
            className={clsx(estilosInputs.inputPadrao, "_mx-2")}
            value={(tipoEntregaSelecionado) ?? ""}
            onChange={(e) => setTipoEntregaSelecionado(e.target.value)}
        >
            <option value="">Selecione</option>
            {props.entregas?.map((entrega) => (
                <option key={entrega.Value} value={entrega.Value}>
                    {entrega.Description}
                </option>
            ))}
        </select>
    </div>

    const tiposEntrega = (notaFiscal: DadosNotaFiscal) => {
        
        return <>
            {tipoEntregaSelecionado == notaFiscal.SiglaTipoEntrega || !tipoEntregaSelecionado ?
                <div>
                    <div className="_my-3 _w-full _bg-[#f5f5f5] _mb-0 _py-3 _px-4  _rounded-t-lg _border _border-gray-300 _font-semibold notafiscalcanhoto">
                        <h4>
                            <label className="hover:_cursor-pointer hover:_text-[#409fff]" onClick={() => props.onSelecionarMostrarTipoEntrega(!props.mostrarDetalhesTipoEntrega, notaFiscal)}>
                                {
                                    'Filial' + notaFiscal.DescricaoFilial +
                                    ' - Nota: ' + notaFiscal.Numero +
                                    ' - Série: ' + notaFiscal.Serie +
                                    ' - Emissão: ' + globalMU.formatDate(notaFiscal.DataEmissao) +
                                    ' - Valor: ' + (Number.isNaN(Number(notaFiscal.ValorTotal)) ? 'R$ **,**' : globalMU.formatarValorNumerico(notaFiscal.ValorTotal, 2, true)) +
                                    ' - Entrega: ' + notaFiscal.DescricaoTipoEntrega
                                }
                            </label>
                        </h4>
                    </div>
                    {props.mostrarDetalhesTipoEntrega && props.notaFiscalSelecionada.Codigo == notaFiscal.Codigo &&
                        <div className="_bg-[#ffffff] _p-4 b _border _border-gray-300 _border-t-0">
                            <div className="_flex _items-start">
                                <div>
                                    <div className="_flex _items-center">
                                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Filial</label>
                                        <p className="_mb-0 _p-2">{notaFiscal.DescricaoFilial}</p>
                                    </div>
                                    <div className="_flex _items-center">
                                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Número</label>
                                        <p className="_mb-0 _p-2">{notaFiscal.Numero}</p>
                                    </div>
                                    <div className="_flex _items-center">
                                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Série</label>
                                        <p className="_mb-0 _p-2">{notaFiscal.Serie}</p>
                                    </div>
                                    <div className="_flex _items-center">
                                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">TPO</label>
                                        <p className="_mb-0 _p-2">{notaFiscal.DescricaoTpo}</p>
                                    </div>
                                    <div className="_flex _items-center">
                                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Total</label>
                                        <p className="_mb-0 _p-2">{Number.isNaN(Number(notaFiscal.ValorTotal)) ? "R$ **,**" : globalMU.formatarValorNumerico(notaFiscal.ValorTotal, 2, true)}</p>
                                    </div>
                                    <div className="_flex _items-center">
                                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Canhoto</label>
                                        <p className="_mb-0">
                                            <button  title="Visualiza as imagens/vídeos do produto"
                                            className={clsx(estilosBotoes.botaoIcone, "no-global-button")}
                                            >
                                            <FontAwesomeIcon
                                                icon={faCamera}
                                                onClick={() =>
                                                props.onMostrarImagem(notaFiscal.Codigo)
                                                }
                                            />
                                            </button>
                                        </p>
                                    </div>
                                    <div className="_flex _items-center">
                                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Data Emissão</label>
                                        <p className="_mb-0 _p-2">{globalMU.formatDate(notaFiscal.DataEmissao)}</p>
                                    </div>
                                    <div className="_flex _items-center">
                                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Data Venda</label>
                                        <p className="_mb-0 _p-2">{globalMU.formatDateTime(notaFiscal.DataVenda)}</p>
                                    </div>
                                    <div className="_flex _items-center">
                                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Data Saída</label>
                                        <p className="_mb-0 _p-2">{globalMU.formatDateTime(notaFiscal.DataSaida)}</p>
                                    </div>
                                    <div className="_flex _items-center">
                                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Frete</label>
                                        <p className="_mb-0 _p-2">{globalMU.formatarValorNumerico(notaFiscal.ValorFrete, 2, true)}</p>
                                    </div>
                                    <div className="_flex _items-center">
                                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Seguro</label>
                                        <p className="_mb-0 _p-2">{globalMU.formatarValorNumerico(notaFiscal.ValorSeguro, 2, true)}</p>
                                    </div>
                                    <div className="_flex _items-center">
                                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Desconto</label>
                                        <p className="_mb-0 _p-2">{globalMU.formatarValorNumerico(notaFiscal.ValorDesconto, 2, true)}</p>
                                    </div>
                                    <div className="_flex _items-center">
                                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Cliente</label>
                                        <p className="_mb-0 _p-2">{notaFiscal.NomeCliente}</p>
                                    </div>
                                    <div className="_flex _items-center">
                                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">CPF/CNPJ	</label>
                                        <p className="_mb-0 _p-2">{notaFiscal.CpfCnpj}</p>
                                    </div>
                                    <div className="_flex _items-center">
                                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Data Cancelamento</label>
                                        <p className="_mb-0 _p-2">{globalMU.formatDate(notaFiscal.DataCancelamento)}</p>
                                    </div>
                                    <div className="_flex _items-center">
                                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Tipo</label>
                                        <p className="_mb-0 _p-2">{notaFiscal.DescricaoTipo}</p>
                                    </div>
                                    <div className="_flex _items-center">
                                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Chave NFe</label>
                                        <p className="_mb-0 _p-2">{notaFiscal.ChaveNFe}</p>
                                    </div>
                                    <div className="_flex _items-center">
                                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Situação NFe</label>
                                        <p className="_mb-0 _p-2">{notaFiscal.DescricaoSituacaoNFe}</p>
                                    </div>
                                    <div className="_flex _items-center">
                                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Tipo Entrega</label>
                                        <p className="_mb-0 _p-2">{notaFiscal.DescricaoTipoEntrega}</p>
                                    </div>
                                    <div className="_flex _items-center">
                                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Data Entrega</label>
                                        <p className="_mb-0 _p-2">{globalMU.formatDate(notaFiscal.DataEntrega)}</p>
                                    </div>
                                    <div className="_flex _items-center">
                                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Número Cupom</label>
                                        <p className="_mb-0 _p-2">{notaFiscal.NumeroCupom}</p>
                                    </div>
                                    <div className="_flex _items-center">
                                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Série Cupoma</label>
                                        <p className="_mb-0 _p-2">{notaFiscal.SerieCupom}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                :
                <div />
            }
        </>
    }


    return (
        <div className="_mb-4">

            {cabecalho}

            {entrega}

            {props.notasFiscais?.map((notafiscal) => {
                return tiposEntrega(notafiscal)
            })}

        </div>
    )

}